// eslint-disable-next-line no-restricted-imports
import moment from 'moment';

import { ignoreOrResolveWordPast } from '../../../../../utils';
import Icon, { regularIcons } from '../../../../generic/Icon';
import Tooltip from '../../../../generic/Tooltip';
import IssueItemBadge from '../IssueItemBadge';
import WithSeparator from '../WithSeparator';

import styles from './IgnoredIssueBadge.module.less';

export type Props = {
  ignoredAt: string;
};

/**
 * Ignored issue badge.
 */
const IgnoredIssueBadge = ({ ignoredAt }: Props) => {
  const ignoredDate = moment(ignoredAt);

  return (
    <WithSeparator>
      <IssueItemBadge>
        <span className={styles.ignoredIcon}>
          <Icon icon={regularIcons.eyeSlashRegular} />
        </span>
        <Tooltip id="ignored-issue-badge" tooltip={ignoredDate.format(moment.localeData().longDateFormat('L'))}>
          <span>{ignoreOrResolveWordPast()} {ignoredDate.fromNow()}</span>
        </Tooltip>
      </IssueItemBadge>
    </WithSeparator>
  );
};

export default IgnoredIssueBadge;
